import * as React from "react";
import {cx} from "emotion";
import {bindInput} from "../../../../../../react/bind-input";
import "./input.scss";

export const Input = ({state, xdQaName=undefined, className=undefined, ...props}) => (
    <input {...{
        ...props,
        className: cx("input-1s1", className),
        "xd-qa-type": "text_field",
        "xd-qa-name": xdQaName,
        ...bindInput(state),
    }}/>
);
